import { Box, Paper, Stack, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Cell,
  LabelList,
} from "recharts";
import {
  blackColor,
  blackShade19,
  whiteColor,
} from "../../../configs/styles/muiThemes";

// Function to format currency with ₹ symbol
const formatCurrency = (value) => `₹ ${value.toLocaleString("en-IN")}`;

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <Paper
        elevation={3}
        sx={{ p: "3px 6px", borderRadius: 1, bgcolor: whiteColor }}
      >
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 500,
            color: blackShade19,
            lineHeight: 1.5,
          }}
        >
          {label}
        </Typography>
        <Box>
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 400,
              color: blackShade19,
              lineHeight: 1.5,
            }}
          >
            Orders: {payload[0].payload.orderCount}
          </Typography>
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 400,
              color: blackShade19,
              lineHeight: 1.5,
            }}
          >
            Total Sales: {formatCurrency(payload[0].payload.totalSales)}
          </Typography>
        </Box>
      </Paper>
    );
  }
  return null;
};

function SalesByYearChart({ data }) {
  return (
    <Stack
      sx={{
        border: "1px solid #E1E8F0",
        borderRadius: "10px",
        p: "10px 15px 0",
        // gap: 1,
      }}
      minHeight={"100%"}
    >
      <Typography
        fontSize={13.5}
        fontWeight={600}
        color={blackShade19}
        lineHeight="20px"
      >
        Order & Sales By Year
      </Typography>
      <ResponsiveContainer width="100%" height={190}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 0, left: -50, bottom: 0 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            vertical={false}
            horizontal={false}
          />

          {/* X-Axis Configuration */}
          <XAxis
            dataKey="timePeriod"
            axisLine={{ stroke: "#000" }}
            tickLine={false}
            tick={{ fill: blackShade19, fontSize: 11, fontWeight: 500 }}
          />

          {/* Y-Axis Configuration */}
          <YAxis axisLine={false} tickLine={false} tick={false} />

          {/* Tooltip with Custom Formatter */}
          <Tooltip
            content={<CustomTooltip />}
            cursor={{ fill: "transparent" }}
          />

          {/* Bar Configuration */}
          <Bar dataKey="orderCount" barSize={20} radius={[10, 10, 0, 0]}>
            {data?.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={index % 2 === 0 ? "#00C49F" : "#0088FE"}
              />
            ))}

            <LabelList
              dataKey="orderCount"
              content={({ x, y, width, height, value }) => (
                <text
                  x={x + width / 2}
                  y={y + height - 20}
                  textAnchor="middle"
                  alignmentBaseline="middle"
                  transform={`rotate(-90, ${x + width / 2}, ${
                    y + height - 20
                  })`}
                  fill="#fff"
                  fontSize={12}
                  fontWeight={600}
                >
                  {value}
                </text>
              )}
            />

            {/* Display Total Sales Above Bars */}
            <LabelList
              dataKey="totalSales"
              content={({ x, y, width, value }) => (
                <text
                  x={x + width / 2}
                  y={y - 10}
                  textAnchor="middle"
                  fill="#000"
                  fontSize={12}
                  fontWeight={500}
                >
                  {formatCurrency(value)}
                </text>
              )}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Stack>
  );
}

export default SalesByYearChart;
